<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
        size="small"
        >添加
      </el-button>
      <el-input
        v-model="listQuery.username"
        placeholder="成员账号"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.name"
        placeholder="成员名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="正常" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <!--      <el-select v-model="listQuery.cooperation_type" placeholder="合作类型" clearable style="width: 120px" class="filter-item"-->
      <!--                 size="small">-->
      <!--        <el-option label="账期合作" value="account_term"/>-->
      <!--        <el-option label="预充值合作" value="advance_recharge"/>-->
      <!--      </el-select>-->
      <!--      <el-select v-model="listQuery.account_term_cycle" placeholder="账期周期" clearable style="width: 120px" class="filter-item"-->
      <!--                 size="small">-->
      <!--        <el-option label="周结" value="weekly_settlement"/>-->
      <!--        <el-option label="半月结" value="half_month_settlement"/>-->
      <!--        <el-option label="月结" value="monthly_settlement"/>-->
      <!--      </el-select>-->
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="成员账号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <el-table-column label="成员名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="成员全称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.full_name }}
        </template>
      </el-table-column>
      <!--      <el-table-column label="合作类型" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tag v-if="scope.row.cooperation_type === 'account_term'" type="primary">账期合作</el-tag>-->
      <!--          <el-tag v-else-if="scope.row.cooperation_type === 'advance_recharge'" type="success">预充值合作</el-tag>-->
      <!--          <el-tag v-else type="warning">-</el-tag>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="账期周期" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tag v-if="scope.row.account_term_cycle === 'weekly_settlement'" type="primary">周结</el-tag>-->
      <!--          <el-tag v-else-if="scope.row.account_term_cycle === 'half_month_settlement'" type="success">半月结</el-tag>-->
      <!--          <el-tag v-else-if="scope.row.account_term_cycle === 'monthly_settlement'" type="warning">月结</el-tag>-->
      <!--          <el-tag v-else type="warning">-</el-tag>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_phone }}
        </template>
      </el-table-column>
      <el-table-column label="联系邮箱" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_email }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
      <!--      <el-table-column label="App ID" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="visibleSecrets[scope.$index]">-->
      <!--            {{ scope.row.app_id }}-->
      <!--          </div>-->
      <!--          <div v-else>-->
      <!--            <el-button type="text" @click="openPasswordPrompt(scope.$index, scope.row)">-->
      <!--              <i class="el-icon-view"></i>-->
      <!--            </el-button>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="App Secret" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="visibleSecrets[scope.$index]">-->
      <!--            {{ scope.row.app_secret }}-->
      <!--          </div>-->
      <!--          <div v-else>-->
      <!--            <el-button type="text" @click="openPasswordPrompt(scope.$index, scope.row)">-->
      <!--              <i class="el-icon-view"></i>-->
      <!--            </el-button>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="IP白名单" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.ips || "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="上级渠道名称" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.channel ? scope.row.channel.name : "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="渠道ID" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.channel_id || "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="上级佣金比率(%)" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.channel_commission_rate * 100 || "-" }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="加价比率(%)" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel_price_rate * 100 || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.is_normal == 1"
            type="warning"
            size="mini"
            @click="handleStatus(scope.row.id, 0)"
          >
            禁用
          </el-button>
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, 1)"
            >解禁</el-button
          >
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="primary"
              @click="handleUpdate1(scope.row)"
              >常用信息修改
            </el-button>
            <el-button
              size="mini"
              type="warning"
              @click="initPassword(scope.row.id, 1)"
              >初始化密码</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="130px"
        style="margin-left: 50px"
      >
        <el-form-item label="成员账号" prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="成员名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="成员全称" prop="full_name">
          <el-input v-model="form.full_name" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_phone">
          <el-input v-model="form.contact_phone" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contact_email">
          <el-input v-model="form.contact_email" />
        </el-form-item>
        <el-form-item label="加价比率(%)" prop="contact_email">
          <el-input-number
            v-model="form.channel_price_rate"
            :min="0"
            style="margin-left: 10px; flex: 1"
            placeholder="加价比率"
          />
        </el-form-item>
        <el-form-item label="状态" prop="is_normal">
          <el-select v-model="form.is_normal">
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="常用信息修改"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form1"
        :rules="rules1"
        :model="form1"
        label-position="left"
        label-width="150px"
        style="margin-left: 50px"
      >
        <el-form-item label="购买方名称" prop="buyer_name">
          <el-input v-model="form1.buyer_name" />
        </el-form-item>
        <el-form-item label="购买方纳税人识别号" prop="buyer_taxpayer_no">
          <el-input v-model="form1.buyer_taxpayer_no" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form1.address" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form1.phone" />
        </el-form-item>
        <el-form-item label="开户行" prop="bank">
          <el-input v-model="form1.bank" />
        </el-form-item>
        <el-form-item label="银行卡号" prop="bank">
          <el-input v-model="form1.bank_no" />
        </el-form-item>
        <el-form-item label="纳税人资质" prop="taxpayer_qualification_type">
          <el-select v-model="form1.taxpayer_qualification_type">
            <el-option label="小微企业" :value="1" />
            <el-option label="一般纳税人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoicing_type">
          <el-select v-model="form1.invoicing_type">
            <el-option label="普通发票" :value="1" />
            <el-option label="专用发票" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发送邮箱" prop="email">
          <el-input v-model="form1.email" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form1.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" type="password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'

export default {
  components: { uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      channel: { name: '' },
      form: {
        id: '',
        name: undefined,
        full_name: undefined,
        contact_phone: undefined,
        contact_email: undefined,
        channel_price_rate: 0,
        is_normal: 1,
        ips: undefined,
      },
      rules: {
        username: [
          { required: true, message: '客户账号不能为空', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' },
        ],
        full_name: [
          { required: true, message: '客户全称不能为空', trigger: 'blur' },
        ],
        contact_phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
        ],
        contact_email: [
          { required: true, message: '联系邮箱不能为空', trigger: 'blur' },
        ],
        is_normal: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
        channel_price_rate: [
          { required: true, message: '加价比率不能为空', trigger: 'blur' },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        bank_no: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      apiAccountList: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    openPasswordPrompt(index, row) {
      this.currentRow = row
      this.currentIndex = index
      this.form2.id = row.id
      this.dialogVisible2 = true
    },
    confirmPassword() {
      request({
        url: '/api/appClientend/app-client/get-secret',
        method: 'get',
        params: this.form2,
      }).then((response) => {
        this.$set(this.visibleSecrets, this.currentIndex, true)
        this.list[this.currentIndex].app_id = response.data.app_id
        this.list[this.currentIndex].app_secret = response.data.app_secret
        this.dialogVisible2 = false
      })
    },
    getChannelData(id) {
      this.channel.name = null
      request({
        url: '/api/appClientend/channel/detail',
        method: 'get',
        params: {
          id,
        },
      }).then((response) => {
        if (response.data) {
          this.channel = response.data
        }
      })
    },

    getApiAccountList() {
      this.channel.name = null
      request({
        url: '/api/appClientend/member/list',
        method: 'get',
        params: {
          limit: 9999999999,
        },
      }).then((response) => {
        if (response.data) {
          this.apiAccountList = response.data.data
        }
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/appClientend/member/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        name: undefined,
        is_normal: 1,
        ips: undefined,
        channel_price_rate: 0,
      }
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign(
        {
          imgArray: [
            'http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png',
            'http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png',
          ],
        },
        row,
      ) // copy obj
      // this.form.channel_commission_rate = this.form.channel_commission_rate * 100
      this.form.channel_price_rate = this.form.channel_price_rate * 100

      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          var form = JSON.parse(JSON.stringify(this.form))

          form.channel_price_rate = form.channel_price_rate / 100

          request({
            url: '/api/appClientend/member/store',
            method: 'post',
            data: form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleUpdate1(row) {
      this.form1 = Object.assign({}, row.info) // copy obj
      this.form1.member_id = row.id
      this.dialogStatus1 = 'update'
      this.dialogFormVisible1 = true
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
    },
    saveData1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true
          request({
            url: '/api/appClientend/member/store-info',
            method: 'post',
            data: this.form1,
          })
            .then((response) => {
              this.btnLoading1 = false
              this.dialogFormVisible1 = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading1 = false
            })
        }
      })
    },
    handleStatus(id, isNormal) {
      this.$confirm('此操作将修改客户端状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/appClientend/member/change-status',
            method: 'post',
            data: { id: id, is_normal: isNormal },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    initPassword(id) {
      this.$confirm('此操作将初始化密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/appClientend/member/init-password',
            method: 'post',
            data: { id: id },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

::v-deep(.el-form-item__content) {
  max-width: 400px;
}
</style>
